import { render } from "./Admin_Proveedores.vue?vue&type=template&id=0f67dbe3"
import script from "./Admin_Proveedores.vue?vue&type=script&lang=js"
export * from "./Admin_Proveedores.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__